<template>
  <component :is="pickerComponent" :horizontal v-model:date="date"
    @showYears="pickerComponent = DatePickerYears"
    @showMonths="pickerComponent = DatePickerMonths"
    @yearSelected="onYearSelected"
    @monthSelected="onMonthSelected"
  ></component>
</template>

<script setup>
import { computed, shallowRef, watch } from "vue";
import DatePickerDays from "./DatePickerDays.vue";
import DatePickerYears from "./DatePickerYears.vue";
import DatePickerMonths from "./DatePickerMonths.vue";
import { zoneDate } from "./timezones.js";

let props = defineProps({
  date: Date,
  horizontal: Boolean
});

let date = defineModel("date");
let pickerComponent = shallowRef(DatePickerDays);
watch(date, () => {
  pickerComponent.value = DatePickerDays;
});

let dateOrNow = computed(() => {
  let timezone =  store.sessions[0].system.timezone.value;
  return props.date ?? zoneDate(new Date(), timezone);
});

function onYearSelected(year) {
  let newDate = new Date(dateOrNow.value);
  newDate.setUTCFullYear(year);
  date.value = newDate;
}

function onMonthSelected(month) {
  let newDate = new Date(dateOrNow.value);
  newDate.setUTCMonth(month);
  date.value = newDate;
}
</script>